import React from 'react';
import { Box, ButtonIcon, Icon, Typography } from '@saviynt/design-system';

import { CF_NEU_BLD, testIds } from '../../../../shared/constants';

import WaypointProgressChip from './WaypointProgressChip';

interface WayPointNameProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  wayPointName: string;
  progressPercentage: number;
}

/**
 * WayPointName
 */
function WayPointName({
  isOpen,
  setIsOpen,
  wayPointName,
  progressPercentage,
}: WayPointNameProps) {
  return (
    <Box tag='div' className='WayPointName' dataTestId={testIds.WAYPOINT_NAME}>
      <Box tag='div' className='WayPointName-iconWrapper'>
        <Icon kind='Workflow' size='smallMedium' />
        {isOpen && (
          <span className='ChatLeftPanel-WayPointLayout-workflowStepsConnector' />
        )}
      </Box>

      <Box tag='div' className='WayPointName-content'>
        <Typography kind='h4' color={CF_NEU_BLD}>
          {wayPointName}
        </Typography>
        <WaypointProgressChip
          progressPercentage={progressPercentage}
          isChipIcon
        />
      </Box>
      <ButtonIcon
        size='small'
        kind='ghost'
        icon={
          <Icon kind={isOpen ? 'ChevronUp' : 'ChevronDown'} size='xSmall' />
        }
        className='WayPointName-expandBtn'
        ariaLabel={isOpen ? 'Collapse' : 'Expand'}
        onClick={() => setIsOpen(!isOpen)}
        dataTestId={testIds.CHAT_LEFT_PANEL_WAYPOINT_EXPAND_BTN}
      />
    </Box>
  );
}

export default WayPointName;
